import { styled } from '@mui/material';

export const RecordsItemWrapper = styled('div')(() => ({
  width: '100%',
}));

export const RecordValueWrapper = styled('div')<{ asColumns: boolean }>(({ asColumns }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flexWrap: asColumns ? 'wrap' : 'nowrap',
  overflow: 'hidden',
  width: '100%',
  minWidth: 0,
}));
